module.exports = __webpack_public_path__ + "img/code6.7d4cc516.png";